export const SAVE_WBS_STATE_ATTR = 'uprice/SAVE_WBS_STATE_ATTR';

export const COPY_WBS_TO_PROJECT = 'uprice/COPY_WBS_TO_PROJECT';
export const COPY_WBS_TO_PROJECT_SUCCESS = 'uprice/COPY_WBS_TO_PROJECT_SUCCESS';
export const COPY_WBS_TO_PROJECT_FAIL = 'uprice/COPY_WBS_TO_PROJECT_FAIL';
